var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-grid',{ref:"grid",attrs:{"url":"purimGifts","baseUrl":_vm.getDomain(),"columns":_vm.columns,"title":_vm.title,"navigationPath":"PurimStudentView","navigationField":"studentID"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }